import { Box } from "@mui/material";
import { useTableLayoutClasses } from "../TableLayout.style";

import { LOGO_RESOURCES, PARTS_RESOURCES } from "../../../../configuration/Resources";
import useBrands from "../../../../../explorer/hooks/useBrands";

type TPartMccLogoComponent = {
    item: any;
};

const PartMccLogoComponent = (props: TPartMccLogoComponent) => {
    const classes = useTableLayoutClasses();
    
    const currentBrand = useBrands().currentBrand;
    const _mcc = props.item.manufacturerCompanyCode ?? props.item.manufacturerCompany;

    const _mccData = currentBrand!.manufacturers.find(
        (manufacturer) => manufacturer.code === _mcc
    );
    const logo = _mccData ? _mccData.logo : null;


    return (
        <Box sx={[classes.columnLogo]}>
            {logo && logo !== "" && (
                <img
                    style={classes.logoImg}
                    src={`${LOGO_RESOURCES}/${logo}`}
                ></img>
            )}
        </Box>
    );
};

export default PartMccLogoComponent;
